// CART - BASE FUNCTIONS
let CartListo = {
  // Retrieve current cart state
  getCart: async function () {
    try {
      let response = await fetch('/cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
      });
      let cart = await response.json();
      return cart;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  // Modify cart level properties (use null values with attribute keys to remove them)
  updateCart: async function (attributes, note, sections) {
    let formData = {
      attributes: {
        ...attributes,
      },
      note: note,
      sections: sections,
    };
    try {
      let response = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
        body: JSON.stringify(formData),
      });
      let cart = await response.json();
      return cart;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  // Add item to cart
  addCartItem: async function (variantId, quantity, properties, sections) {
    let formData = {
      items: [
        {
          id: variantId,
          quantity: quantity,
          properties: { ...properties },
        },
      ],
      sections: sections,
    };
    try {
      let response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
        body: JSON.stringify(formData),
      });
      let cart = await response.json();
      return cart;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  // Modify cart item
  updateCartItem: async function (lineItemKey, quantity, properties, sections) {
    let formData = {
      id: lineItemKey,
      quantity: quantity,
      properties: { ...properties },
      sections: sections,
    };
    try {
      let response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
        body: JSON.stringify(formData),
      });
      let cart = await response.json();
      return cart;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  // Remove item from cart
  removeCartItem: async function (lineItemKey, sections) {
    let formData = {
      id: lineItemKey,
      quantity: 0,
      sections: sections,
    };
    try {
      let response = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
        body: JSON.stringify(formData),
      });
      let cart = await response.json();
      return cart;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  // Remove all items from cart
  clearCartItems: async function (sections) {
    let formData = {
      sections: sections,
    };
    try {
      let response = await fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'xmlhttprequest',
        },
        body: JSON.stringify(formData),
      });
      let cart = await response.json();
      return cart;
    } catch (error) {
      console.error(error);
      return null;
    }
  },
};

// CART - EVENT LISTENERS

// Add custom event listeners to window by overriding base fetch and xhr methods
window.addEventListener(
  'load',
  function () {
    let CartEvents = {
      add: 'shopifyCartEvent:add',
      update: 'shopifyCartEvent:update',
      change: 'shopifyCartEvent:change',
      clear: 'shopifyCartEvent:clear',
      mutate: 'shopifyCartEvent:mutate',
    };

    let ShopifyCartURLs = [
      '/cart/add',
      '/cart/update',
      '/cart/change',
      '/cart/clear',
      '/cart/add.js',
      '/cart/update.js',
      '/cart/change.js',
      '/cart/clear.js',
    ];

    function isShopifyCartURL(url) {
      if (!url) return false;
      let path = url.split('/').pop();
      return ShopifyCartURLs.includes(`/cart/${path}`);
    }

    function updateType(url) {
      if (!url) return false;
      if (url.includes('cart/add')) {
        return 'add';
      } else if (url.includes('cart/update')) {
        return 'update';
      } else if (url.includes('cart/change')) {
        return 'change';
      } else if (url.includes('cart/clear')) {
        return 'clear';
      } else return false;
    }

    function dispatchEvent(url, detail) {
      if (typeof detail === 'string') {
        try {
          detail = JSON.parse(detail);
        } catch {}
      }

      window.dispatchEvent(new CustomEvent(CartEvents.mutate, { detail }));
      let type = updateType(url);
      switch (type) {
        case 'add':
          window.dispatchEvent(new CustomEvent(CartEvents.add, { detail }));
          break;
        case 'update':
          window.dispatchEvent(new CustomEvent(CartEvents.update, { detail }));
          break;
        case 'change':
          window.dispatchEvent(new CustomEvent(CartEvents.change, { detail }));
          break;
        case 'clear':
          window.dispatchEvent(new CustomEvent(CartEvents.clear, { detail }));
          break;
        default:
          break;
      }
    }

    function XHROverride() {
      if (!window.XMLHttpRequest) return;

      let originalOpen = window.XMLHttpRequest.prototype.open;
      window.XMLHttpRequest.prototype.open = function () {
        let url = arguments[1];
        this.addEventListener('load', function () {
          if (isShopifyCartURL(url)) {
            dispatchEvent(url, this.response);
          }
        });
        return originalOpen.apply(this, arguments);
      };
    }

    function fetchOverride() {
      if (!window.fetch || typeof window.fetch !== 'function') return;
      let originalFetch = window.fetch;
      window.fetch = function () {
        let response = originalFetch.apply(this, arguments);

        if (isShopifyCartURL(arguments[0])) {
          response.then((res) => {
            res
              .clone()
              .json()
              .then((data) => dispatchEvent(res.url, data));
          });
        }

        return response;
      };
    }

    fetchOverride();
    XHROverride();
  },
  true,
);
